import { description } from "platform";

export const MAIN_PLANS = [
    {
        name: "bibliotecas",
        title: {
            default: 'Plan Bibliotecas',
            translationPath: 'libraries.title'
        },
        class: "libraries",
        img: {
            src:"/img/que-es/home/plans/bibliotecas.png",
            alt:""
        },
        description: {
            default: 'Ideal para bibliotecas e instituciones que quieren aumentar el acceso y la participación lectora.',
            translationPath: 'libraries.description'
        },
        list: [
            {
                default: 'Acceso dentro y fuera de la biblioteca',
                translationPath: 'libraries.item1'
            },
            {
                default: 'Libros infantiles y juveniles para toda la comunidad',
                translationPath: 'libraries.item2'
            },
            {
                default: 'Guías y recursos para mediadores de lectura',
                translationPath: 'libraries.item3'
            },
            {
                default: 'Reportes para medir impacto lector',
                translationPath: 'libraries.item4'
            }
        ],
        link:"/que-es/bibliotecas"
    },
    {
        name: "colegios",
        title: {
            default: 'Plan Colegios',
            translationPath: 'schools.title'
        },
        class: "schools",
        img: {
            src: "/img/que-es/home/plans/colegios.png",
            alt:""
        },
        description: {
            default: 'Ideal para colegios e instituciones que buscan fomentar la lectura y medir el progreso académico.',
            translationPath: 'schools.description'
        },
        list: [
            {
                default: 'Biblioteca digital para docentes y estudiantes',
                translationPath: 'schools.item1'
            },
            {
                default: 'Métricas de lectura por estudiante y clase',
                translationPath: 'schools.item2'
            },
            {
                default: 'Recursos pedagógicos para el aula',
                translationPath: 'schools.item3'
            },
            {
                default: 'Perfil personalizado para cada usuario',
                translationPath: 'schools.item4'
            }
        ],
        link:"/que-es/colegios"
    }
]